interface Props {
    onSearch?: (query: string) => void;
}

const _CollectionSearch: React.FC<Props> = ({ onSearch }) => {
    return (
        <div className="actions-container">
            <div className="search-container">
                <i className="fas fa-search"></i>
                <input
                    type="text"
                    className="search-input form-control"
                    placeholder="Recherche... "
                    onChange={(e) => onSearch?.(e.target.value)}
                />
            </div>
        </div>
    )
}

export default _CollectionSearch
